import { Reducer } from 'redux';
import { DepositanteState, DepositanteTypes } from './types';

const INITIAL_STATE: DepositanteState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<DepositanteState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DepositanteTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DepositanteTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case DepositanteTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case DepositanteTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
